import { MDXRemote } from 'next-mdx-remote';
import styled from 'styled-components';

import HeroSection from 'components/HeroSection';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import { Grid, columns } from 'styles/grid';

import { components } from './MarkdownStyles';

const Container = styled.div`
  background-color: ${COLORS.pinkMuted};
`;

const Markdown = styled.main`
  ${columns(null, 12)}
  padding: 50px 0;
  color: ${({ color }) => color || COLORS.forest};

  ${BREAKPOINTS.small`
    ${columns(2, 9)}
  `}

  ${BREAKPOINTS.medium`
    padding: 105px 0 72px;
  `}

  ${BREAKPOINTS.large`
    padding: 140px 0 95px;
  `}
`;

const StaticPage = ({ page: { title, subtitle, markdown, bgColor } }) => {
  return (
    <Container>
      <HeroSection title={title} subtitle={subtitle} bgColor={bgColor?.hex} />
      {markdown && (
        <Grid>
          <Markdown color={bgColor?.hex}>
            <MDXRemote {...markdown} components={components} />
          </Markdown>
        </Grid>
      )}
    </Container>
  );
};

export default StaticPage;
